import { ReviewDecisionActions } from '@/components/common/ReviewDecision';
import { INACTIVATE_SUBMISSION_TYPE } from '../constants/instituteSubmission.constants';
import { useReviewInstituteSubmission } from '../hooks/useReviewInstituteSubmission';
import type { InstituteSubmissionDetail } from '../types/instituteSubmission.types';

const INACTIVATION_APPROVAL_WARNING =
  'Approving makes this institute inactive. It is also removed from every user it is mapped to, and its teachers become inactive. Making the institute active again does not undo this.';

interface InstituteSubmissionReviewActionsProps {
  submission: InstituteSubmissionDetail;
}

export function InstituteSubmissionReviewActions({
  submission,
}: InstituteSubmissionReviewActionsProps) {
  const reviewMutation = useReviewInstituteSubmission();

  return (
    <ReviewDecisionActions
      isPending={reviewMutation.isPending}
      approveWarning={
        submission.submissionType === INACTIVATE_SUBMISSION_TYPE
          ? INACTIVATION_APPROVAL_WARNING
          : undefined
      }
      onSubmit={(decision, payload, onDone) =>
        reviewMutation.mutate({ id: submission.id, decision, payload }, { onSuccess: onDone })
      }
    />
  );
}
